// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"131":"73812a46c47cb6d4abb2","914":"0a220a60897b5dcb6330","987":"ec2f8d864ed13e483874"}[chunkId] + ".bundle.js";
};